import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  TextField,
  Typography,
  FormHelperText,
  FormControlLabel,
  Radio,
  RadioGroup,
  Checkbox,
  Switch,
  Button,
  IconButton,
  Box,
  Tooltip,
  Autocomplete,
  Modal,
  Paper,
} from "@mui/material";
import { isFieldVisible, validateForm } from "./formUtils";
import formConfig from "./formConfig";

const DocumentRequirements = ({
  formData,
  setFormData,
  errors,
  setErrors,
  formMode,
  handleChange,
}) => {
  const handleCheckboxChange = (e) => {
    handleChange(e); // Use parent's handleChange to update formData
    // const updatedErrors = validateForm(formData, formData.instrument);
    // setErrors(updatedErrors); // Update errors after state change
  };

  const handleTextChange = (e) => {
    handleChange(e); // Use parent's handleChange
  };

  // Ensure requiredDocuments is always an object
  const safeRequiredDocuments = formData.requiredDocuments || {
    commercialInvoice: false,
    billOfLading: false,
    certificateOfAnalysis: false,
    packingList: false,
    certificateOfOrigin: false,
    insurancePolicy: false,
    inspectionCertificate: false,
    claimDocs: false,
    underlyingContract: false,
    guaranteeTextDraft: false,
  };

  return (
    <div className="tab-pane active">
      <div className="row g-3">
        {isFieldVisible(
          "requiredDocuments",
          formData.instrument,
          formConfig
        ) && (
          <div className="col-md-12">
            <FormControl
              fullWidth
              disabled={formMode === "view"}
              error={!!errors.requiredDocuments}
            >
              <Typography variant="body2">Documents Required</Typography>
              <div className="d-flex flex-wrap gap-3">
                {[
                  { label: "Commercial Invoice", name: "commercialInvoice" },
                  { label: "Bill of Lading", name: "billOfLading" },
                  { label: "Claim Docs", name: "claimDocs" },
                  { label: "Underlying Contract", name: "underlyingContract" },
                  { label: "Guarantee Text Draft", name: "guaranteeTextDraft" },
                  { label: "Packing List", name: "packingList" },
                  {
                    label: "Certificate of Origin",
                    name: "certificateOfOrigin",
                  },
                  { label: "Insurance Policy", name: "insurancePolicy" },
                  {
                    label: "Inspection Certificate",
                    name: "inspectionCertificate",
                  },
                ].map((doc) => (
                  <FormControlLabel
                    key={doc.name}
                    control={
                      <Checkbox
                        name={doc.name}
                        checked={!!formData.requiredDocuments[doc.name]}
                        onChange={handleChange}
                        size="small"
                        sx={{
                          color: "#de6b14",
                          "&.Mui-checked": {
                            color: "#de6b14",
                          },
                        }}
                      />
                    }
                    label={doc.label}
                  />
                ))}
              </div>
            </FormControl>
          </div>
        )}
        {isFieldVisible(
          "additionalDocuments",
          formData.instrument,
          formConfig
        ) && (
          <div className="col-md-12">
            <FormControl
              fullWidth
              disabled={formMode === "view"}
              error={!!errors.additionalDocuments}
            >
              <Typography variant="body2">Additional Documents</Typography>
              <textarea
                id="additionalDocuments"
                className="form-control"
                rows="3"
                name="additionalDocuments"
                value={formData.additionalDocuments}
                onChange={handleChange}
                disabled={formMode === "view"}
              />
              {errors.additionalDocuments && (
                <FormHelperText>{errors.additionalDocuments}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        {isFieldVisible(
          "specialConditions",
          formData.instrument,
          formConfig
        ) && (
          <div className="col-md-12">
            <FormControl fullWidth disabled={formMode === "view"} error={!!errors.specialConditions}>
              <Typography variant="body2">
                Special Conditions / Clauses (Optional)
              </Typography>
              <textarea
                id="specialConditions"
                className="form-control"
                rows="3"
                name="specialConditions"
                value={formData.specialConditions}
                onChange={handleChange}
                disabled={formMode === "view"}
              />
              {errors.specialConditions && (
                <FormHelperText>{errors.specialConditions}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
      </div>
    </div>
  );
};

export default DocumentRequirements;
